import { render, staticRenderFns } from "./academy_teachers.vue?vue&type=template&id=3f0b3e0a&scoped=true"
import script from "./academy_teachers.vue?vue&type=script&lang=js"
export * from "./academy_teachers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0b3e0a",
  null
  
)

export default component.exports